import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Whether CSV import is enabled for customers in Portal.
 */
export const schema = z.boolean();

export type EnableCsvImport = z.infer<typeof schema>;

export const definition = define({
  key: 'enable_csv_import',
  schema,
  label: 'Enable CSV Import',
  description:
    'Activate/Deactivate the CSV import feature for customers in Portal. When enabled, the customer can import moves via CSV file upload.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
